import DataTable from "@shared/ui/data-table/DataTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledIncomes } from "./incomes.styled";
import { useIncomeOptions } from "./incomes.data";
import { useIncomeStructures } from "./useIncomeStructures";
import { useIncomesBrowse } from "./useIncomesBrowse";
import { useIncomesNavigation } from "./useIncomesNavigation";

function Incomes() {
  const theme = useTheme();
  const { tableStructure } = useIncomeStructures();
  const browse = useIncomesBrowse();
  const navigation = useIncomesNavigation();
  const incomeOptions = useIncomeOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledIncomes>
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          searchForm={browse.accountSearchForm}
          onResetSearch={browse.reset}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={incomeOptions}
          pagination={{
            page: browse.page,
            perPage: browse.perPage,
            hasNextPage: browse.hasNextPage,
            hasPrevPage: browse.hasPrevPage,
            onNextPage: browse.handleNextPage,
            onPrevPage: browse.handlePrevPage,
            onRowsPerPageChange: browse.handleRowsPerPageChange,
          }}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledIncomes>
  );
}

export default Incomes;
